import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  type: 'keyword' | 'welcome' | 'away';
  trigger?: string;
  response: { type: 'text'; body: string };
  enabled?: boolean;
  priority?: number;
};

type MutationResponse = {
  status: number;
  data: { rule_id: string };
};

export const useCreateAutoReplyMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while creating the auto-reply rule',
    endpoint: '/api/admin/whatsapp/auto-replies',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
